import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Actions_Wind from '~/Actions_Wind';
import Left_Windmill from 'images/Left_Windmill.png';
import Mid_Windmill from 'images/Mid_Windmill.png';
import Right_Windmill from 'images/Right_Windmill.png';
import BCIF_Container from '../BCIF_Container';
import Wind from './Wind';
import Transport from './Transport';
import Item from './Item';

const proportion = 0.3;

const Png = ({ open, src, right, width, height }) => (
  <img
    style={{
      position: 'absolute',
      bottom: 0,
      right: open ? right : right * proportion,
      width: open ? width : width * proportion,
      height: open ? height : height * proportion,
      pointerEvents: 'none',
      opacity: open ? 0.5 : 0,
      transition: 'all 2s',
      objectFit: 'contain',
    }}
    src={src}
    alt=''
  />
);

const Png1 = ({ open }) => <Png {...{ open, src: Left_Windmill, right: 243, width: 57, height: 150 }} />;

const Png2 = ({ open }) => <Png {...{ open, src: Mid_Windmill, right: 152, width: 74, height: 194 }} />;

const Png3 = ({ open }) => <Png {...{ open, src: Right_Windmill, right: 127, width: 49, height: 137 }} />;

const App = ({ windId }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    Actions_Wind.getBIPWind(dispatch, { windId: windId || localStorage.getItem('Wind_ID') });
    Actions_Wind.getBIPTransport(dispatch, { windId: windId || localStorage.getItem('Wind_ID') });
    Actions_Wind.getBIPItem(dispatch, { windId: windId || localStorage.getItem('Wind_ID') });
    return () => {
      Actions_Wind.clearKey(dispatch, { key: 'BIPWind' });
      Actions_Wind.clearKey(dispatch, { key: 'BIPTransport' });
      Actions_Wind.clearKey(dispatch, { key: 'BIPItem' });
    };
  }, []);
  return (
    <BCIF_Container title='碼頭資訊' defaultOpen={false}>
      <div style={{ display: 'flex', marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
        <Wind />
        <div style={{ flex: 1 }} />
        <Transport />
      </div>
      <Item />
      <Png1 />
      <Png2 />
      <Png3 />
    </BCIF_Container>
  );
};

export default App;
